export default __webpack_public_path__ + "static/infos-e44ac4e0c93320488c57493420c844f7.png";